module.exports = __webpack_public_path__ + "media/icons-for-sprite/icon-arrow-left--white-515f045f.svg";